import { MyOrgUnitAssortmentsDTO, OrgUnitAssortmentDTO } from '@retail/auth/types';
import { OrgUnitType } from './OrgUnitType';

export interface OrgUnitAssortment extends OrgUnitAssortmentDTO {
  orgUnitType: OrgUnitType;
  priceLists?: OrgUnitAssortment[];
}

export const toOrgUnitAssortment = (dto: OrgUnitAssortmentDTO): OrgUnitAssortment => ({
  ...dto,
  orgUnitType: OrgUnitType.getOrgUnitType(dto),
  priceLists: dto.priceLists?.map(toOrgUnitAssortment),
});

export const toOrgUnitAssortments = ({
  brandAssortment,
  dataOwnerAssortments,
  locationAssortments,
}: MyOrgUnitAssortmentsDTO): OrgUnitAssortment[] =>
  [
    ...locationAssortments,
    ...(dataOwnerAssortments ?? []),
    ...(brandAssortment ? [brandAssortment] : []),
  ].map(toOrgUnitAssortment);

export const flattenOrgUnitAssortments = (assortments: OrgUnitAssortment[]): OrgUnitAssortment[] =>
  assortments.flatMap((assortment) => [assortment, ...(assortment.priceLists ?? [])]);
